<template>
  <div class="cooperate-partner-wrapper">
    <div class="title-img-wrapper">
      <img class="title-img" :src="source('cooperate-title')" alt="">
    </div>
    <el-carousel height="17.29vw" indicator-position="none">
      <el-carousel-item ref="itemRef" v-for="(item,idx) in swiperList" :key="idx">
        <div class="cooperate-list-wrapper">
          <img class="item" v-for="(it,i) in item" :key="i" :src="it.fileUrl" alt="">
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'cooperate-partner',
  data() {
    return {
      swiperList: []
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME_COOPERATE, name).fileUrl
    },
  },
  created() {
    const list = key.get(key.HOME_COOPERATE)
    const filterList = list.filter(item => item.resourceName !== 'cooperate-title')
    const num = Math.ceil(filterList.length / 5)
    console.log(num)
    for (let i = 0; i < num; i++) {
      this.swiperList.push(filterList.splice(0, 5))
    }
  }
}
</script>


<style scoped lang="scss">
.cooperate-partner-wrapper {
  width: 100%;

  .title-img-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 3.49vw;
    width: 100%;

    .title-img {
      width: 66.384vw;
      height: 16.851vw;
    }
  }

  .cooperate-list-wrapper {
    width: 100%;
    margin-top: 3.802vw;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .item {
      max-width: 15.625vw;
      max-height: 8.333vw;
    }
  }
}
</style>
